import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';

import type { TAlfaleasingCompanyBannerDesktop } from '../models';

export const AlfaleasingCompanyBanner: FC<TAlfaleasingCompanyBannerDesktop> = ({
    Text,
    backgroundImageUrl = 'https://storage.yandexcloud.net/alfaleasing/trucks/banner/company-banner.png',
    columnsData,
    styles,
    title,
}) => (
    <div className={cn(styles.external, styles.mainWrapper)}>
        <div className={cn(styles.external, styles.wrapper)}>
            <div className={cn(styles.external, styles.bannerGradientTop)} />
            <div
                className={cn(styles.external, styles.banner)}
                style={{
                    backgroundImage: `url(${backgroundImageUrl})`,
                }}
            />
            <div className={cn(styles.external, styles.bannerGradientBottom)} />
            <div className={cn(styles.external, styles.innerWrapper)}>
                <Text className={cn(styles.external, styles.subText)} view="primary-large">
                    {title.text}
                </Text>
                <Text className={cn(styles.external, styles.headerTitle)} tag="h5" view="xlarge">
                    {title.title}
                </Text>

                <div className={cn(styles.external, styles.infoCard)}>
                    <Text className={cn(styles.external, styles.titleBig)} tag="div">
                        {columnsData[0].title}
                    </Text>
                    <Text className={cn(styles.external, styles.text)} view="primary-large">
                        {columnsData[0].text}
                    </Text>
                </div>
                <div className={cn(styles.external, styles.statisticsWrapper)}>
                    {columnsData.slice(1).map(({ text, title: columnTitle }, idx) => (
                        <div key={idx} className={cn(styles.external, styles.infoCard)}>
                            <Text className={cn(styles.external, styles.title)} tag="div">
                                {columnTitle}
                            </Text>
                            <Text className={cn(styles.external, styles.text)} view="primary-large">
                                {text}
                            </Text>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);
